const { REACT_APP_NAME } = process.env;

import { Box, Button, Typography } from '@mui/material'
import { Outlet } from 'react-router'
import { Link, NavLink } from 'react-router-dom';
import PageContainer from 'src/components/container/PageContainer'
import { AddNewAdsButton } from 'src/components/pages/p2p/AddNewAdsButton';
import { palette } from 'src/theme/style/palette';

export const P2pLayout = () => {
    return (
        <>
            <PageContainer title={`${REACT_APP_NAME} | P2P`} description="P2P обмен внутренней валюты между пользователя платформы">
                <Box mb={3} display='flex' alignItems='center' justifyContent='space-between'>
                    <Typography variant='h4'>P2P обменник</Typography>
                </Box>

                <Box>
                    <Box mb={3} display="flex" flexWrap="wrap" gap={1}>
                        <AddNewAdsButton pos={`relative`} />
                        <Button
                            component={NavLink}
                            to="/office/p2p"
                            end // важен для точного совпадения, чтобы не было активным на вложенных страницах
                            sx={{
                                '&.active': {
                                    backgroundColor: palette.blue,
                                    color: '#fff',
                                },
                            }}
                        >
                            Объявления
                        </Button>

                        <Button
                            component={NavLink}
                            to="/office/p2p/broni"
                            sx={{
                                '&.active': {
                                    backgroundColor: palette.blue,
                                    color: '#fff',
                                },
                            }}
                        >
                            Я забронировал
                        </Button>

                        <Button
                            component={NavLink}
                            to="/office/p2p/moi-obyavleniya"
                            sx={{
                                '&.active': {
                                    backgroundColor: palette.blue,
                                    color: '#fff',
                                },
                            }}
                        >
                            Мои объявления
                        </Button>

                        <Button
                            component={NavLink}
                            to="/office/p2p/reqvizity"
                            sx={{
                                '&.active': {
                                    backgroundColor: palette.blue,
                                    color: '#fff',
                                },
                            }}
                        >
                            Реквизиты
                        </Button>
                    </Box>
                    <Outlet />
                </Box>


            </PageContainer>
        </>
    )
}
